import { render } from "./rule.vue?vue&type=template&id=11ce2b4f&scoped=true"
const script = {}

import "./rule.vue?vue&type=style&index=0&id=11ce2b4f&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ce2b4f"]])

export default __exports__